import React from 'react';

import DateBox from 'devextreme-react/date-box';
import Button from 'devextreme-react/button';


export const FormDateBox = ({
  value,
  readOnly,
  name,
  label,
  allowClear,
  onValueChange,
  showEndOfYearButton = false,
  children
}) => {
  const handleEndOfYearClick = () => {
    const currentYear = new Date().getFullYear();
    const endOfYear = new Date(currentYear, 11, 31); // 31. Dezember
    if (onValueChange) {
      onValueChange(endOfYear);
    }
  };

  return (
    <DateBox
      value={value}
      readOnly={readOnly}
      name={name}
      label={label}
      inputAttr={{ class: 'form-editor-input' }}
      stylingMode='filled'
      buttons={[{name:'endOfYear',options:{visible: (showEndOfYearButton && !readOnly), text: (new Date()).getFullYear(), onClick: handleEndOfYearClick}, location: 'after' },'dropDown']}
      displayFormat='dd.MM.yyyy'
      allowClear={true}
      onValueChange={onValueChange}
    >
      {children}
    </DateBox>
  );
};
